






























import CancelButton from '@/components/buttons/CancelButton.vue'
import SubmitButton from '@/components/buttons/SubmitButton.vue'
import CardTitle from '@/components/CardTitle.vue'
import Vue from 'vue'
import { TranslateResult } from 'vue-i18n'

export default Vue.extend({
  name: 'ConfirmationModal',
  components: { SubmitButton, CancelButton, CardTitle },
  props: {
    title: {
      type: String as () => TranslateResult,
      default: '',
    },
    text: {
      type: String as () => TranslateResult,
      default: '',
    },
    appearance: {
      type: String,
      default: 'ghost',
    },
    hue: {
      type: String,
      default: 'contract',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
  },
  data: function (): {
    dialog: boolean
  } {
    return {
      dialog: false,
    }
  },
  computed: {
    ariaLabel(): string {
      return String(this.title)
    },
    triggerClasses(): string[] {
      const list = []
      if (this.appearance === 'danger') {
        list.push('bid-action-trigger--danger')
        return list
      }
      list.push(`bid-action-trigger--${this.appearance}`)
      list.push(`bid-action-trigger--hue-${this.hue}`)
      return list
    },
  },
  methods: {
    open(): void {
      if (this.disabled) return
      this.dialog = true
    },
    submit(): void {
      this.dialog = false
      this.$emit('confirmed')
    },
  },
})
